/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Car = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M17.2619 3C18.1452 3 18.9238 3.57934 19.1776 4.4253L20.033 7.277L20.4594 6H23V7.5H21.541L21.04 9.001L21.1493 9.00549C22.1841 9.08183 23 9.94564 23 11V20C23 20.5523 22.5523 21 22 21H19C18.4477 21 18 20.5523 18 20V18H6V20C6 20.5523 5.55228 21 5 21H2C1.44772 21 1 20.5523 1 20V11C1 9.90915 1.87332 9.02228 2.95893 9.00041L2.459 7.5H1V6H3.54057L3.966 7.278L4.82241 4.4253C5.0762 3.57934 5.85485 3 6.73806 3H17.2619ZM4.5 18H2.5V19.5H4.5V18ZM21.5 18H19.5V19.5H21.5V18ZM21 10.5H3C2.72386 10.5 2.5 10.7239 2.5 11V16.5H21.5V11C21.5 10.7545 21.3231 10.5504 21.0899 10.5081L21 10.5ZM8 12.75V14.25H4V12.75H8ZM20 12.75V14.25H16V12.75H20ZM17.2619 4.5H6.73806C6.51726 4.5 6.3226 4.64483 6.25915 4.85633L5.015 9H18.984L17.7409 4.85633C17.6853 4.67127 17.5294 4.53725 17.3433 4.50664L17.2619 4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
